import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import { Values } from "@src/Tools/Values";
import PositionTeamsContent from "./PositionTeamsContent/PositionTeamsContent";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class PositionTeams extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getPositionTeams(),
        this.props.management.getActivePositions(),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("positionTeams");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <PositionTeamsContent />}</div>;
  }
}

export default PositionTeams;
